import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const TwoWayArrows = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 25 25' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M7.373 21.06 4.08 17.769a1 1 0 0 1 0-1.415l3.293-3.293m9.5-1.5 3.293-3.292a1 1 0 0 0 0-1.415l-3.293-3.292m-11.75 13.5h15.25m-16.5-9.5h15.5'
        stroke='currentColor'
        stroke-width='1.5'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    ) : (
      <path
        d='M7.373 21.06 4.08 17.769a1 1 0 0 1 0-1.415l3.293-3.293m9.5-1.5 3.293-3.292a1 1 0 0 0 0-1.415l-3.293-3.292m-11.75 13.5h15.25m-16.5-9.5h15.5'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    )}
  </IconBase>
);
